import { Router } from '@angular/router';
import { WrapperStandardFilter } from '../../common/models/wrapper.model';
import { GenericService } from '../../services/base/generic-service';
import { GenericListView } from '../genericlistview/generic-list-view';

export class GenericCFLViewProperties<T> extends GenericListView<T> { 

    private _title: string = "";
    private _sortColumn: string = "";
    private _height: string = "";
    private _width: string = "";
    private _cflViewDataSourceURL: string = "";
    private _displyedCflColumnList: Array<string> = [];
    private _identifier: string = "";
    private _selectedData: any;
    private _isItSingleSelection: boolean = true;
    private _isCancel: boolean = true;

    private _CflFilterArray: Array<WrapperStandardFilter> = new Array<WrapperStandardFilter>();

    private _isItEnumList: boolean = false;
    private _cflEnumObjectNameToDisplay: string = "";
    private _dbStoreName: string = "";
    private _enumDataToStoreInDB: any;
    private _setCFLNumberType: any;
    private _setCFLStringType: any;
    private _setCFLRequestDataCode: any;
    private _setCFLRequestDataInnerArrayName: string = "";
    constructor(agenericRepository: GenericService<T>, router: Router) {
        super(agenericRepository, router);
    };

    public get getCflTitle(): any {
        return this._title;
    };
    public set setCflTitle(value: any) {
        this._title = value;
    };
    public get getCFLIsCancel(): any {
        return this._isCancel;
    };
    public set setCFLIsCancel(value: any) {
        this._isCancel = value;
    };

    public get getSortColumn(): any {
        return this._sortColumn;
    };
    public set setSortColumn(value: any) {
        this._sortColumn = value;
        //this.getRequestData.SortColumn = value;
    };
    public get getCflHeight(): any {
        return this._height;
    };
    public set setCflHeight(value: any) {
        this._height = value;
    };
    public get getCflWidth(): any {
        return this._width;
    };
    public set setCflWidth(value: any) {
        this._width = value;
    };
    public get getCflViewDataSourceURL(): any {
        return this._cflViewDataSourceURL;
    };
    public set setCflViewDataSourceURL(value: any) {
        this._cflViewDataSourceURL = value;
    };
    public get getCflIdentifier(): any {
        return this._identifier;
    };
    public set setCflIdentifier(value: any) {
        this._identifier = value;
    }
    public get getCflSelectedData(): any {
        return this._selectedData;
    }
    public set setCflSelectedData(value: any) {
        this._selectedData = value;
    }
    public get getIsCflSingleSelection(): boolean {
        return this._isItSingleSelection;
    }
    public set setIsCflSingleSelection(value: boolean) {
        this._isItSingleSelection = value;
    }
    public get getCflDisplayedColumnsNamesList(): Array<string> {
        return this._displyedCflColumnList;
    };
    public set setCflDisplayedColumnsNamesList(value: Array<any>) {
        this._displyedCflColumnList = value;
    };
    public set setCflFilterArray(value: WrapperStandardFilter) {
        this._CflFilterArray.push(value);
        //this.getRequestData.RequestData = this._CflFilterArray;
    };
    public get getCflFilterArray(): Array<WrapperStandardFilter> {
        return this._CflFilterArray;
    };
    public get getIsItCflEnumList(): boolean {
        return this._isItEnumList;
    }
    public set setIsItCflEnumList(value: boolean) {
        this._isItEnumList = value;
    }
    public get getCflEnumObjectNameToDisplay(): any {
        return this._cflEnumObjectNameToDisplay;
    };
    public set setCflEnumObjectNameToDisplay(value: any) {
        this._cflEnumObjectNameToDisplay = value;
    }
    public get getCflEnumStoreName(): string {
        return this._dbStoreName;
    };
    public set setCflEnumStoreName(value: string) {
        this._dbStoreName = value;
    }
    public get getCflEnumDataToStoreInDB(): any {
        return this._enumDataToStoreInDB;
    };
    public set setCflEnumDataToStoreInDB(value: any) {
        this._enumDataToStoreInDB = value;
    }

    public get getCFLNumberType(): any {
        return this._setCFLNumberType;
    };
    public set setCFLNumberType(value: any) {
        this._setCFLNumberType = value;
    };


    public get getCFLStringType(): any {
        return this._setCFLStringType;
    };
    public set setCFLStringType(value: any) {
        this._setCFLStringType = value;
    };

    public get getCFLRequestDataWithCode(): any {
        return this._setCFLRequestDataCode;
    };
    public set setCFLRequestDataWithCode(value: any) {
        this._setCFLRequestDataCode = value;
    };

    public get getCFLRequestDataInnerObjName(): any {
        return this._setCFLRequestDataInnerArrayName;
    };
    public set setCFLRequestDataInnerObjName(value: any) {
        this._setCFLRequestDataInnerArrayName = value;
    };
}
